// extracted by mini-css-extract-plugin
module.exports = {"mgt10":"mgt10_1E48O","mgt20":"mgt20_2FfPv","mgt40":"mgt40_2VKFX","mgt60":"mgt60_Ts8_5","mgt80":"mgt80_3HGGg","mgt100":"mgt100_24-TK","main":"main_36fwO"};